import {
    BrindesFornecedorActionsTypes,
    type BrindesFornecedorActions,
} from "./brindesFornecedorActions"
import {
    BrindesFornecedorInicial,
    type BrindesFornecedorModel,
} from "../models/brindesFornecedorModel"

export { BrindesFornecedorInicial }

export function brindesFornecedorReducer(
    state: BrindesFornecedorModel,
    action: BrindesFornecedorActions
): BrindesFornecedorModel {
    switch (action.type) {
        case BrindesFornecedorActionsTypes.CARREGAR:
            return { ...state, brindes: action.payload }
        default:
            return state
    }
}
